import { CSSProperties, cx } from '@linaria/core';
import { memo, ReactNode } from 'react';
import "./Loading.linaria.module.css!=!./Loading?./Loading.linaria.module.css?css=H4sIAAAAAAAAA12QzW7DIBAG732PSu2BKFhR47gPgzAshpiwLqx/EtR3r5rUTu3j6JuVBnaSLsIowe0Hnvvbbo353Cdy5soUBoJAlYJAED+/X+6ijILX3QFbtcFsPExMuwiKHIZKoe8vYT67tCJRGMsyd5jcXZB1Qt8TzIpdBS2UpXdNYI7gkjYtRy84lqU9qKzQY6wGGd8YsyA1REYw0fusnpLgNI1u8Fm71Hl5rX575xkKwTF9YTFkC66xVPH9/nVeh+uyjk6TXY2FFk2YVHtaU66lapuIfdDsf5yOcoTInuuSqJLgI29KbTeYDQZi46OrRq+fP2Ci8HuIZsoeiCCy1EnlQlMddsdueZ1v/6w15U5q7ULDPBhaX6hScDNOYYANPlqSu0HFi7v/A8jBp4ZOAgAA"
const rootStyles = "atm_fc_1h6ojuz atm_ar_1bp4okc atm_mk_stnw88 atm_h_1h6ojuz atm_7l_1o88h4c atm_9s_1txwivl atm_e2_1osqo2v atm_vy_1osqo2v atm_2d_gnxck9";
const loadingStyles = "atm_cs_1w1g8dh atm_fr_l0erfx atm_lk_l0erfx atm_c8_1fwxnve atm_7l_1o88h4c";
interface ILoading {
  children?: ReactNode;
  className?: string;
  hideText?: boolean;
  style?: CSSProperties;
  text?: string;
}
const Loading = memo((props: ILoading) => {
  const {
    hideText,
    text = 'LOADING...',
    style,
    children,
    className
  } = props;
  return <div style={style} className={cx(rootStyles, className)}>
            {!hideText && <span className={loadingStyles}>{text}</span>}
            {children}
        </div>;
});
export default Loading;